// extracted by mini-css-extract-plugin
export default {"root":"Description_root__X+iqg","title":"Description_title__9tdno","content":"Description_content__SbHzN"};